// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"02f46e99","128":"24d89fa7","240":"b3086058","241":"d5d58a02","505":"0acafd4a","696":"226f9d6e","805":"fba6c35a","885":"2eb87555","996":"7ba6cddc"}[chunkId] + ".chunk.js";
};